const pastDateColor = "#e8e8e8"

export default pastDateColor